<template>
  <div class="my-2 ml-2">
    <div>
      <v-icon
        v-if="passwordHasMinCharacters(password)"
        class="mr-2 mr-md-3"
        color="green"
      >
        mdi-check-circle-outline
      </v-icon>
      <v-icon v-else class="mr-2 mr-md-3" color="red">
        mdi-alert-circle-outline
      </v-icon>
      <span>Must have at least {{ passwordMinLength() }} characters</span>
    </div>
    <div>
      <v-icon
        v-if="passwordHasNumber(password)"
        class="mr-2 mr-md-3"
        color="green"
      >
        mdi-check-circle-outline
      </v-icon>
      <v-icon v-else class="mr-2 mr-md-3" color="red">
        mdi-alert-circle-outline
      </v-icon>
      <span>Must contain at least 1 number</span>
    </div>
    <div>
      <v-icon
        v-if="passwordHasLowerCase(password)"
        class="mr-2 mr-md-3"
        color="green"
      >
        mdi-check-circle-outline
      </v-icon>
      <v-icon v-else class="mr-2 mr-md-3" color="red">
        mdi-alert-circle-outline
      </v-icon>
      <span>Must contain at least 1 lower case</span>
    </div>
    <div>
      <v-icon
        v-if="passwordHasUpperCase(password)"
        class="mr-2 mr-md-3"
        color="green"
      >
        mdi-check-circle-outline
      </v-icon>
      <v-icon v-else class="mr-2 mr-md-3" color="red">
        mdi-alert-circle-outline
      </v-icon>
      <span>Must contain at least 1 UPPER case</span>
    </div>
    <div>
      <v-icon
        v-if="passwordHasNoLeadingOrTrailingWhitespace(password)"
        class="mr-2 mr-md-3"
        color="green"
      >
        mdi-check-circle-outline
      </v-icon>
      <v-icon v-else class="mr-2 mr-md-3" color="red">
        mdi-alert-circle-outline
      </v-icon>
      <span>NO leading or trailing spaces</span>
    </div>
    <div>
      <v-icon
        v-if="passwordHasSpecialCharacter(password)"
        class="mr-2 mr-md-3"
        color="green"
      >
        mdi-check-circle-outline
      </v-icon>
      <v-icon v-else class="mr-2 mr-md-3" color="red">
        mdi-alert-circle-outline
      </v-icon>
      <span
        >Must contain at least 1
        <span
          class="i-tooltip-outer-text"
          v-tooltip.right="{ ref: 'specialCharactersToolTipContent' }"
          >special character</span
        >
      </span>
      <div ref="specialCharactersToolTipContent">
        Supported special characters are: <br />
        <pre
          style="margin-top: 4px; white-space: pre-wrap; word-wrap: break-word"
          >{{ allowedSpecialChars.join(' ') }}</pre>
      </div>
    </div>
  </div>
</template>

<script>
import PasswordHelper from '@/components/helpers/PasswordHelper'

export default {
  props: {
    password: {
      type: String,
      required: true
    }
  },

  data: () => ({}),

  computed: {
    allowedSpecialChars() {
      return PasswordHelper.allowedSpecialChars()
    }
  },

  methods: {
    passwordHasMinCharacters(password) {
      return PasswordHelper.passwordHasMinCharacters(password)
    },

    passwordHasNumber(password) {
      return PasswordHelper.passwordHasNumber(password)
    },

    passwordMinLength() {
      return PasswordHelper.passwordMinLength()
    },

    passwordHasLowerCase(password) {
      return PasswordHelper.passwordHasLowerCase(password)
    },

    passwordHasUpperCase(password) {
      return PasswordHelper.passwordHasUpperCase(password)
    },

    passwordHasNoLeadingOrTrailingWhitespace(password) {
      return PasswordHelper.passwordHasNoLeadingOrTrailingWhitespace(password)
    },

    passwordHasSpecialCharacter(password) {
      return PasswordHelper.passwordHasSpecialCharacter(password)
    }
  }
}
</script>

<style scoped></style>
